'use client'

import { useEffect } from 'react'

import { initStatsigOnce } from '../../lib/analytics/statsig'

/**
 * Mounts once at the app root, mirroring UsePostHog.ts's lifecycle.
 * MYQRCODE-10817 — install/init only, see lib/analytics/statsig.ts.
 */
export const UseStatsig = () => {
	useEffect(() => {
		initStatsigOnce()
	}, [])

	return null
}
